import script from "./SpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingAnalysisPage.vue?vue&type=style&index=0&id=74829d6e&scoped=true&lang=css"
import "./SpendingAnalysisPage.vue?vue&type=style&index=1&id=74829d6e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74829d6e"]])

export default __exports__